import {getEntryTimeString, noCategoryResources} from '@/library/modules/calendar/calendar';
import {calendarResourceOptions} from '@/library/modules/calendar/options';
import {type Ref, computed} from 'vue';

export function useCalendarEntryViewContent<T extends CalendarEntryData = CalendarEntryData>(
    entry: Ref<Optional<T>>,
    calendar: Ref<Optional<CurrentCalendarData | CalendarData>>,
)
{

    const entryTimeString = computed(() => getEntryTimeString(entry.value!, false));

    const showAddress = computed(() => !!(calendar.value!.street
        || calendar.value!.street_number
        || calendar.value!.street_addition
        || calendar.value!.postcode
        || calendar.value!.city));

    const isCalendarEntry = computed(() => entry.value!.resource && Object.keys(calendarResourceOptions).includes(entry.value!.resource));

    return {
        noCategoryResources,
        entryTimeString,
        showAddress,
        isCalendarEntry,
    };
}